import EventDetailsPageComponent from "./components/EventDetailsPageComponent.js";
import { useEffect } from "react";

import { useDispatch, useSelector } from "react-redux";


import { addToCartEvent } from "../redux/actions/cartActions";
import axios from 'axios'

const getEventDetails = async(id) => {
    const { data } = await axios.get(`/api/events/get-one/${id}`);
    return data
}

const writeReviewApiRequest = async (eventId, formInputs) => {
    const { data } = await axios.post(`/api/users/review/${eventId}`, { ...formInputs });
    return data;
}

const EventDetailsPage = () => {

    const dispatch = useDispatch()

    const userInfo = useSelector((state) => state.userRegisterLogin.userInfo);


  return <EventDetailsPageComponent  addToCartReduxAction={addToCartEvent} reduxDispatch={dispatch} getEventDetails={getEventDetails} userInfo={userInfo}  writeReviewApiRequest={writeReviewApiRequest} />;
};

export default EventDetailsPage;
